import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './Styles/App.scss';
import App from './App'; 
import { Provider } from 'react-redux';
import store from './Redux/store'


ReactDOM.render(
  <React.StrictMode>
     <Provider store={store}>
       <App />
     </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);


